import { Badge } from "@/components/ui/Badge";
import { ALL_VEHICLE_CHASSIS } from "@/data";
import { selectActiveForce, useForceStore } from "@/store/forceStore";

export function VehicleBrowser() {
	const force = useForceStore(selectActiveForce);
	const addVehicle = useForceStore((s) => s.addVehicle);

	if (!force) return null;

	const faction = force.faction;

	const vehicles = ALL_VEHICLE_CHASSIS.filter((v) => v.faction === faction || v.faction === "both");

	if (vehicles.length === 0) return null;

	return (
		<div className="space-y-2">
			<h3 className="text-xs font-semibold text-text-muted uppercase tracking-wider px-1">
				Add Vehicle
			</h3>
			<div className="flex flex-col gap-1.5">
				{vehicles.map((v) => (
					<button
						key={v.id}
						type="button"
						onClick={() => addVehicle(v.id)}
						className="text-left px-3 py-2.5 rounded-md text-sm transition-all cursor-pointer text-text-secondary hover:bg-bg-tertiary border border-transparent hover:border-border-default group"
					>
						<div className="flex items-center justify-between">
							<span className="font-medium group-hover:text-text-primary">{v.name}</span>
							<Badge variant="amber" size="sm">
								{v.baseCost}r
							</Badge>
						</div>
						{v.notes && <div className="text-xs text-text-muted mt-0.5">{v.notes}</div>}
					</button>
				))}
			</div>
		</div>
	);
}
